/*
 * Copyright (c) 2026 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */

/** A way to contact MTa directly from a link. */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();type ContactMethod = 'email' | 'phone' | 'whatsapp' | 'booking'

/** The hosts of WhatsApp chat links. */
const WHATSAPP_HOSTS = ['wa.me', 'api.whatsapp.com']

/**
 * Works out which contact method a click was on, from the link that contains the clicked element. Returns `undefined`
 * when the click was not on an email, phone, WhatsApp or Microsoft Bookings link.
 *
 * @param target - the element that was clicked
 */
const contactMethodOf = (target: EventTarget | null): ContactMethod | undefined => {
  if (!(target instanceof Element)) {
    return undefined
  }

  const link = target.closest('a[href]')

  if (!(link instanceof HTMLAnchorElement)) {
    return undefined
  }

  if (link.protocol === 'mailto:') {
    return 'email'
  }

  if (link.protocol === 'tel:') {
    return 'phone'
  }

  if (WHATSAPP_HOSTS.includes(link.hostname)) {
    return 'whatsapp'
  }

  if (
    link.protocol === 'https:' &&
    ((link.hostname === 'bookings.cloud.microsoft' && /^\/book\/[^/]+(?:\/|$)/.test(link.pathname)) ||
      (link.hostname === 'outlook.office365.com' && /^\/owa\/calendar\/[^/]+\/bookings(?:\/|$)/.test(link.pathname)))
  ) {
    return 'booking'
  }

  return undefined
}

export { contactMethodOf, type ContactMethod }
